function removeTrailingSlash(url = '') {
    return url.replace(/\/+$/, '');
}

export { removeTrailingSlash };
